export default [
	{
		tenantId: 'b16e03a6-17bb-4f0c-b316-9ec017e51d5a',
		labels: {
			signUpUserTypeButtonCompany: 'Practice',
			signUpUserTypeContinueButtonCompany: 'Practice',
			signUpUserTypeButtonProfessional: 'Locum',
			signUpUserTypeDescriptionCompany: 'Select above if you own/manage a Practice/Hospital',
			signUpUserTypeDescriptionProfessional: 'Select above if you want to work as a Locum',
			industry: 'Industry',
			industryRequired: 'Industry is required',
		},
	},
	{
		tenantId: '3f5a9c8a-4a78-4723-a9bd-3f43b18fe5be',
		labels: {
			signUpUserTypeButtonCompany: 'Venue',
			signUpUserTypeContinueButtonCompany: 'Venue',
			signUpUserTypeButtonProfessional: 'Shift Seeker',
			signUpUserTypeDescriptionCompany: 'Select above if you want to register as a Venue',
			signUpUserTypeDescriptionProfessional: 'Select above if you want to work as a Shift Seeker',
			industry: 'Primary Area of Expertise',
			industryRequired: 'Primary Area of Expertise is required',
			selectIndustry: 'Select your primary area of expertise',
		},
	},
	{
		tenantId: '76081da2-5fdd-47b0-8caf-2c337ea3bf9f',
		labels: {
			signUpUserTypeButtonCompany: 'Venue',
			signUpUserTypeContinueButtonCompany: 'Venue',
			signUpUserTypeButtonProfessional: 'Shift Seeker',
			signUpUserTypeDescriptionCompany: 'Select above if you want to register as a Venue',
			signUpUserTypeDescriptionProfessional: 'Select above if you want to work as a Shift Seeker',
			industry: 'Primary Area of Expertise',
			industryRequired: 'Primary Area of Expertise is required',
			selectIndustry: 'Select your primary area of expertise',
		},
	},
	{
		tenantId: 'e4f84ffd-cc7d-47d8-ad04-983e73031ba2',
		labels: {
			signUpUserTypeButtonCompany: 'Hospital',
			signUpUserTypeContinueButtonCompany: 'Nursing Manager',
			signUpUserTypeButtonProfessional: 'Nurse',
			signUpUserTypeDescriptionCompany: 'Select above if you manage a team of Nurses',
			signUpUserTypeDescriptionProfessional: 'Select above if you are employed at a hospital',
			industry: 'Industry',
			industryRequired: 'Industry is required',
		},
	},
];
